export default __webpack_public_path__ + "static/10-main-menu-e0ab0e9756b8eb3f8c3c63d19fab642d.png";